export const QueryKey = 'prescription-checkins'
export const PrescriptionCheckins = '/api/v1/prescription-checkins'
